/**
 * Custom functionality for cart page.
 */
(function() {
  // Vue.config.devtools = true;
  const carriers = [
    { value: 'UPS', label: 'UPS', type: 'ground' },
    { value: 'USPS', label: 'USPS', type: 'air' },
    { value: 'FedEx', label: 'FedEx', type: 'air' },
    { value: 'DHL', label: 'DHL (International Only)', type: 'air' }
  ];

  function validCarriers(restrictions) {
    return carriers
      .filter(function(carrier) {
        return restrictions.indexOf(carrier.type) === -1;
      });
  }

  function initialCarrierValue(savedValue, restrictions) {
    const carriers = validCarriers(restrictions);
    const savedCarrier = carriers.filter(function(carrier) {
      return savedValue === carrier.value;
    })[0];
    return savedCarrier ? savedCarrier.value : carriers[0].value;
  }

  const methods = [
    { value: 'UPS Ground', carrier: 'UPS', type: 'ground' },
    { value: 'UPS Three-Day Select', carrier: 'UPS', type: 'ground' },
    { value: 'UPS Second Day Air', carrier: 'UPS', type: 'air' },
    { value: 'UPS Next Day Air', carrier: 'UPS', type: 'air' },
    { value: 'Priority Mail', carrier: 'USPS', type: 'air' },
    { value: 'Priority Mail Express', carrier: 'USPS', type: 'air' },
    { value: 'FedEx 2 Day', carrier: 'FedEx', type: 'air' },
    { value: 'FedEx Standard Overnight', carrier: 'FedEx', type: 'air' },
    { value: 'Express Worldwide', carrier: 'DHL', type: 'air' }
  ];

  function validMethods(carrierValue, restrictions) {
    return methods
      .filter(function(method) {
        return carrierValue === method.carrier
      })
      .filter(function(method) {
        return restrictions.indexOf(method.type) === -1;
      });
  }

  function initialMethodValue(carrierValue, savedValue, restrictions) {
    const methods = validMethods(carrierValue, restrictions);
    const savedMethod = methods.filter(function(method) {
      return savedValue === method.value;
    })[0];
    return savedMethod ? savedMethod.value : methods[0].value;
  }

  function getAppSettings() {
    const settingsElement = document.getElementById('cart-shipping-app-settings');
    if (settingsElement && settingsElement.dataset) {
      return settingsElement.dataset;
    }
    return {
      enabled: '',
      account: '',
      carrier: '',
      method: '',
      restrictions: ''
    }
  }

  // Initialize app on page load.
  let vm = app(getAppSettings());

  // Re-initialize app when cart page is updated via AJAX.
  document.addEventListener('cart:rerendered', function() {
    vm.$destroy();
    vm = app(getAppSettings());
  });

  /**
   * App for handling shipping account.
   *
   * Renders the shipping account UI and outputs hidden inputs with cart attributes.
   */
  function app(settings) {
    return new Vue({
      el: '#cart-shipping-app',
      delimiters: ['(((', ')))'],
      data: function() {
        const restrictions = settings.restrictions.split(',');
        const initialCarrier = initialCarrierValue(settings.carrier, restrictions);
        const initialMethod = initialMethodValue(initialCarrier, settings.method, restrictions);
        return {
          enabled: settings.enabled === 'Yes' ? true : false,
          carrier: initialCarrier,
          method: initialMethod,
          restrictions: restrictions,
          account: settings.account,
        }
      },
      computed: {
        carriers: function() {
          return validCarriers(this.restrictions);
        },
        methods: function() {
          return validMethods(this.carrier, this.restrictions);
        },
        attributes: function() {
          var disabledAttributes = [
            { key: 'Use Shipping Account', value: '' },
            { key: 'Account Number', value: '' },
            { key: 'Carrier', value: '' },
            { key: 'Method', value: '' },
          ]
          var enabledAttributes = [
            { key: 'Use Shipping Account', value: 'Yes' },
            { key: 'Account Number', value: this.account },
            { key: 'Carrier', value: this.carrier },
            { key: 'Method', value: this.method },
          ]
          if (!this.enabled || !this.account || this.account.length < 4) {
            return disabledAttributes;
          }
          return enabledAttributes;
        }
      },
      methods: {
        onChange: function() {
          const self = this;
          const selectedMethod = this.methods.filter(function(method) {
            return method.value === self.method;
          })[0];
          // Set first available method when carrier is changed.
          if (!selectedMethod || selectedMethod.carrier !== this.carrier) {
            this.method = this.methods[0].value
          }
        }
      }
    })
  }

  /**
   * Event handler for clicks on main checkout button.
   *
   * Updates special line item property just before redirecting to checkout.
   *
   * Need to use a delegated event here because the page content can be
   * updated via AJAX.
   */
  document.addEventListener('click', function(event) {
    var button = event.target;
    var form = document.getElementById('cart-form');

    if (button.id !== 'cart-checkout-button' || !form || !window.fetch) return;

    event.preventDefault();

    var formData = new FormData(form);
    var accountNumber = formData.get('attributes[Account Number]');
    var submittingLabel = button.dataset.submitting;

    // Disable submit button.
    button.setAttribute('disabled', 'disabled');
    button.classList.add('button--disabled');
    if (submittingLabel) {
      button.textContent = submittingLabel;
    }

    function getCart() {
      return fetch(window.routes.cartUrl + '.js', {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response) {
          return response.json();
        });
    }

    function updateCart(cart) {
      if (!cart || !cart.items.length) return;
      const firstItem = cart.items[0];
      const itemQuantity = firstItem.quantity;
      const properties = firstItem.properties ? firstItem.properties : {};
      if (accountNumber) {
        properties['_Account Number'] = 'See Order Details';
      }
      else {
        delete properties['_Account Number'];
      }
      return fetch(window.routes.cartChangeUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line: 1,
          quantity: itemQuantity,
          properties: properties
        })
      })
    }

    function proceedToCheckout() {
      // Adding this element will force submission, otherwise
      // submitting will simply refresh the page.
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'checkout');
      input.setAttribute('value', 'Check out');
      form.appendChild(input);
      form.submit();
    }

    getCart()
      .then(updateCart)
      .then(proceedToCheckout)
      .catch(proceedToCheckout);
  });
})();
